module.exports = __webpack_public_path__ + "front/img/i7.58890315.png";